/* eslint-disable @typescript-eslint/no-explicit-any */
import { RetryLink } from '@apollo/client/link/retry';

export interface RetryLinkStrategy {
  /**
   * Initial delay in milliseconds before the retrying a request.
   */
  initialDelay?: number;
  /**
   * Maximum number of retries for a failed request
   */
  maxRetries?: number;
  /**
   * List of operations to blacklist from the retry link strategy
   */
  blacklist?: string[];
}

const DEFAULT_INITIAL_DELAY = 300;
const DEFAULT_MAX_RETRIES = 5;

export const retryLink = (publishError: any, strategy?: RetryLinkStrategy) => {
  const initialDelay = strategy && strategy.initialDelay ? strategy.initialDelay : DEFAULT_INITIAL_DELAY;

  const options: RetryLink.Options = {
    delay: {
      initial: initialDelay,
      max: Infinity,
      jitter: true,
    },
    attempts: (count, operation, error) => {
      const blacklist = strategy && strategy.blacklist ? strategy.blacklist : [];
      if (blacklist.includes(operation.operationName)) {
        return false;
      }

      const maxRetries =
        strategy && typeof strategy.maxRetries === 'number' ? strategy.maxRetries : DEFAULT_MAX_RETRIES;
      if (count < maxRetries) {
        publishError(
          'GRAPHQL_RETRY',
          new Error(`retry=${count} max_retry=${maxRetries} operation=${operation.operationName}`),
        );
      } else {
        publishError('GRAPHQL_RETRY', new Error(`max_retry=${maxRetries} operation=${operation.operationName}`));
      }

      return !!error && count < maxRetries;
    },
  };

  return new RetryLink(options);
};
